const accessCompany = {
    // Company Routes
    ADD_COMPANY: { name: 'Add Company', path: '/add-company' },
    UPDATE_COMPANY: { name: 'Edit Company', path: '/edit-company' },
    COMPANY_LIST: { name: 'Company List', path: '/company-list' },
    DELETE_COMPANY: { name: 'Delete Company', path: '/delete-company' },

    // Company User Routes
    ADD_COMPANY_USER: { name: 'Add Company User', path: '/add-company-user' },
    UPDATE_COMPANY_USER: { name: 'Edit Company User', path: '/edit-company-user' },
    COMPANY_USER_LIST: { name: 'Company User List', path: '/company-user-list' },
    DELETE_COMPANY_USER: { name: 'Delete Company User', path: '/delete-company-user' },

    // Operational User Routes
    ADD_IT_ADMIN: { name: 'Add Operational User', path: '/add-operational-user' },
    UPDATE_IT_ADMIN: { name: 'Update Operational User', path: '/edit-operational-user' },
    IT_ADMIN_LIST: { name: 'Operational User', path: '/operational-user-list' },
    DELETE_IT_ADMIN: { name: 'Delete Operational User', path: '/delete-operational-user' },
    IT_ADMIN_DETAILS: { name: 'Operational User Details', path: '/operational-user-details' },

    // Vendor Routes
    ADD_VENDOR: { name: 'Add Vendor', path: '/add-vendor' },
    UPDATE_VENDOR: { name: 'Update Vendor', path: '/edit-vendor' },
    VENDOR_LIST: { name: 'Vendor List', path: '/vendor-list' },
    DELETE_VENDOR: { name: 'Delete Vendor', path: '/delete-vendor' },
    VENDOR_DETAILS: { name: 'Vendor Details', path: '/vendor-details' },

    // Vendor Employee Routes
    ADD_VENDOR_EMPLOYEE: { name: 'Add Vendor Employee', path: '/add-vendor-employee' },
    UPDATE_VENDOR_EMPLOYEE: { name: 'Update Vendor Employee', path: '/edit-vendor-employee' },
    VENDOR_EMPLOYEE_LIST: { name: 'Vendor Employee List', path: '/vendor-employee-list' },
    DELETE_VENDOR_EMPLOYEE: { name: 'Delete Vendor Employee', path: '/delete-vendor-employee' },
    VENDOR_EMPLOYEE_DETAILS: { name: 'Vendor Employee Details', path: '/vendor-employee-details' },

    // Institute Onboarding Routes
    ADD_INSTITUTE_ONBOARDING: { name: 'Add Institute Onboarding', path: '/add-institute-onboarding' },
    UPDATE_INSTITUTE_ONBOARDING: { name: 'Update Institute Onboarding', path: '/edit-institute-onboarding' },
    INSTITUTE_ONBOARDING_LIST: { name: 'Institute Onboarding List', path: '/institute-onboarding-list' },
    DELETE_INSTITUTE_ONBOARDING: { name: 'Delete Institute Onboarding', path: '/delete-institute-onboarding' },
    INSTITUTE_ONBOARDING_DETAILS: { name: 'Institute Onboarding Details', path: '/institute-onboarding-details' },
    INSTITUTE_APPROVAL: { name: 'Institute Approval', path: '/institute-approval' },
    INSTITUTE_REJECT: { name: 'Institute Reject', path: '/institute-reject' },

    // Branch Office Routes
    ADD_BRANCH_OFFICE: { name: 'Add Branch Office', path: '/add-branch-office' },
    UPDATE_BRANCH_OFFICE: { name: 'Edit Branch Office', path: '/edit-branch-office' },
    BRANCH_OFFICE_LIST: { name: 'Branch Office', path: '/branch-office-list' },
    DELETE_BRANCH_OFFICE: { name: 'Delete Branch Office', path: '/delete-branch-office' },
    BRANCH_OFFICE_DETAILS: { name: 'Branch Office Details', path: '/branch-office-details' },
    BRANCH_OFFICE_APPROVAL: { name: 'Branch Office Approval', path: '/branch-office-approval' },
    BRANCH_OFFICE_REJECT: { name: 'Branch Office Reject', path: '/branch-office-reject' },

    // Branch Course Routes
    BRANCH_COURSE_LIST: { name: 'Branch Course', path: '/branch-course-list' },
    ADD_BRANCH_COURSE: { name: 'Add Branch Course', path: '/add-branch-course' },
    UPDATE_BRANCH_COURSE: { name: 'Update Branch Course', path: '/edit-branch-course' },
    DELETE_BRANCH_COURSE: { name: 'Delete Branch Course', path: '/delete-branch-course' },


    // Test Designer Routes
    TEST_DESIGNER_LIST: { name: 'Test Designer', path: '/test-designer-list' },
    ADD_TEST_DESIGNER: { name: 'Add Test Designer', path: '/add-test-designer' },
    DELETE_TEST_DESIGNER: { name: 'Delete Test Designer', path: '/delete-test-designer' },
    UPDATE_TEST_DESIGNER: { name: 'Update Test Designer', path: '/edit-test-designer' },
    TEST_DESIGNER_DETAILS: { name: 'Test Designer Details', path: '/test-designer-details' },
}

export default accessCompany;
